export function getUrlParam(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

export function copytext(text) {
  var textareaC = document.createElement('textarea');
  textareaC.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘 
  textareaC.value = text;
  document.body.appendChild(textareaC); //将textarea添加为body子元素
  textareaC.select();
  var res = document.execCommand('copy');
  document.body.removeChild(textareaC); //移除DOM元素
  toastr.success(noticeMap ? noticeMap.prop("datapage_toastr_copy") : "已复制到剪贴板。", noticeMap ? noticeMap.prop("toastr_success") : "成功");
  return res;
}
//数组对象去重
export function uniqueArray(arr) {
  var result = [];
  for (let i = 0; i < arr.length; i++) {
    var isFind=false; 
    for (let j = 0; j < result.length; j++) {
      if (arr[i] == result[j]) {
        isFind=true;
        break;
      }
    }
    if(!isFind){
      result.push(arr[i]);
    }
  }
  return result;
}